import React, { useEffect } from 'react';

interface HtmlBlobProps {
  blok: {
    blob?: string;
    url?: string;
    iframe_height: number;
    automatic_resize: boolean;
    scroll_hijack: boolean;
    min_height: boolean
  }
  slot: string;
}

const iframeAutomaticResizeScript = `
  <script script type = "text/javascript">
    window.addEventListener('load', () => {
      window.setTimeout(() => window.frameElement.setAttribute('height', document.body.scrollHeight), 0)
    });
  </script>
`;

const getParsedBlob = (blob: string, iframeHeight: number, shouldAutomaticResize: boolean): string => `
  ${blob}
  ${shouldAutomaticResize && !iframeHeight ? iframeAutomaticResizeScript : ''}
`;

export const HtmlBlob = ({ blok, slot }: HtmlBlobProps): JSX.Element => {
  const {
    blob,
    url,
    iframe_height: iframeHeight,
    automatic_resize: shouldAutomaticResize,
    scroll_hijack: shouldHijackScroll,
    min_height: shouldAddMinHeigt,
  } = blok;

  useEffect(() => {
    if (!shouldHijackScroll) {
      return;
    }
    document?.body.setAttribute('style', 'overflow: hidden');
  }, []);

  const handleIframeHeight = iframeHeight
    ? { height: `${iframeHeight}px` }
    : {};

  const handleMinIframeHeight = shouldAddMinHeigt
    ? { minHeight: '100vh' }
    : {};

  return (
    <iframe
      slot={slot}
      srcDoc={blob ? getParsedBlob(
        blob, iframeHeight, shouldAutomaticResize,
      ) : undefined}
      src={url || undefined}
      style={{
        border: 'none',
        width: '100%',
        ...handleIframeHeight,
        ...handleMinIframeHeight,
      }}
    />
  );
};
